import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { Grommet } from 'grommet';

import theme from './theme';
import { Home, RepoContributors } from './pages';
import { NavHeader } from './components';
import { HomeProvider } from './contexts/HomeContext';
import { RepoProvider } from './contexts/RepoContext';
import { UserProvider } from './contexts/UserContext';
import { User } from './pages/User';

function App() {
  return (
    <Router>
      <Grommet theme={theme} full>
        <NavHeader />
        <Switch>
          <Route exact path="/">
            <HomeProvider>
              <Home />
            </HomeProvider>
          </Route>
          <Route path="/:repo/contributors">
            <RepoProvider>
              <RepoContributors />
            </RepoProvider>
          </Route>
          <Route path="/:username/repos">
            <UserProvider>
              <User />
            </UserProvider>
          </Route>
          <Route render={() => <Redirect to={{ pathname: '/' }} />} />
        </Switch>
      </Grommet>
    </Router>
  );
}

export default App;
